import { render, staticRenderFns } from "./GetUsers.vue?vue&type=template&id=5ace79b0&"
import script from "./GetUsers.vue?vue&type=script&lang=js&"
export * from "./GetUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports